<div class="header-div" *ngIf="!search">
  <img class="header-bg" *ngIf="background !== null" src="{{ background }}" alt="{{ 'header_img' }}">
</div>
<div class="header-div" *ngIf="search">
  <img class="header-bg" *ngIf="background !== null" src="{{ background }}" alt="{{ 'header_img' }}">
</div>

